// src/components/UpdateStatusIndicator.tsx
import React from 'react';

interface UpdateStatus {
  fearGreed: boolean;
  marketCap: boolean;
  googleTrends: boolean;
  ethereumRSI: boolean;
  beaconchain: boolean;
  news: boolean;
  wallets: boolean;
}

interface UpdateStatusIndicatorProps {
  status: UpdateStatus;
}

const UpdateStatusIndicator: React.FC<UpdateStatusIndicatorProps> = ({ status }) => {
  // Get list of currently updating items
  const updatingItems: string[] = [];

  if (status.fearGreed) updatingItems.push('Fear & Greed');
  if (status.marketCap) updatingItems.push('Market Cap');
  if (status.googleTrends) updatingItems.push('Google Trends');
  if (status.ethereumRSI) updatingItems.push('ETH RSI');
  if (status.beaconchain) updatingItems.push('Beaconchain');
  if (status.news) updatingItems.push('News');
  if (status.wallets) updatingItems.push('Whale Wallets');

  // Don't show anything if nothing is updating
  if (updatingItems.length === 0) return null;

  // Build the status message
  const statusMessage = updatingItems.length === 1
    ? `Updating ${updatingItems[0]}...`
    : updatingItems.length === 2
      ? `Updating ${updatingItems[0]} and ${updatingItems[1]}...`
      : `Updating ${updatingItems.slice(0, -1).join(', ')}, and ${updatingItems[updatingItems.length - 1]}...`;

  return (
    <div className="fixed bottom-4 right-4 z-50 bg-dashboard-card-light dark:bg-dashboard-card-dark rounded-lg shadow-lg p-3 max-w-xs border border-gray-200 dark:border-gray-700">
      <div className="flex items-center space-x-3">
        {/* Spinner */}
        <div className="relative">
          <div className="w-5 h-5 border-2 border-blue-200 dark:border-blue-900 rounded-full"></div>
          <div className="w-5 h-5 border-2 border-blue-500 border-t-transparent rounded-full animate-spin absolute top-0 left-0"></div>
        </div>

        {/* Status text */}
        <div className="flex-1">
          <div className="text-sm font-medium text-dashboard-text-light dark:text-dashboard-text-dark">
            {statusMessage}
          </div>

          {/* Progress dots for multiple items */}
          {updatingItems.length > 1 && (
            <div className="flex items-center space-x-1 mt-1">
              {updatingItems.map((item, index) => (
                <div
                  key={item}
                  className="w-1.5 h-1.5 rounded-full bg-blue-500 animate-pulse"
                  style={{ animationDelay: `${index * 150}ms` }}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default UpdateStatusIndicator;
